module.exports = __webpack_public_path__ + "static/a20dc5e0845d2a40d024194ff5dfef60c25d2238f99a9d224754009a05e15142-f4ee15049bd351513553d090c98b0f7b.jpeg";